module.exports = __webpack_public_path__ + "img/kefu@3x.b69fe105.png";